import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '../store';
import { SUCCESS_CODE, LOGOUT_CODE } from '@/config';
import { errorHandle } from '@/api/validate';
import { getYourIP } from '@/utils/getIp.js';
import { resolve } from 'q';

let ip = '127.0.0.1';
getYourIP(ipVal => {
  ip = ipVal;
});
let headReg = /http(s)?\:\/\//;
const createBaseFetch = config => {
  // 创建axios实例
  const service = axios.create({
    timeout: 10000000,
    ...config,
  });
  let canShow = false;
  let logout = false;
  // request拦截器
  service.interceptors.request.use(
    conf => {
      const { notLoading,showTips } = conf;
      canShow = showTips;
      store.dispatch('fetchStart', notLoading);
      if (store.getters.token) {
        conf.headers = {
          reqSource: 'pc',
          token: store.getters.token,
          ip: ip,
          ...conf.headers,
        };
      } else {
        conf.headers = {
          reqSource: 'pc',
          ip: ip,
          ...conf.headers,
        };
      }
      if (headReg.test(conf.url)) {
        conf.url = formateFetchUrl(conf.url);
      } else {
        conf.baseURL = formateFetchUrl(conf.baseURL);
      }

      return conf;
    },
    error => {
      // Do something with request error
      console.error(error); // for debug
      Promise.reject(error);
    }
  );

  // respone拦截器
  service.interceptors.response.use(response => {
    let res = response.data;
    /**
     * code为非'0'是抛错
     */
    setTimeout(() => {
      const { notLoading } = response.config;
      store.dispatch('fetchDone', notLoading);
    }, 500);

    if (
      response.headers &&
      response.headers['content-type'] &&
      !/json/.test(response.headers['content-type'].toLowerCase())
    ) {
      return response;
    }

    if (response.request.responseType === 'arraybuffer') {
      const text = Buffer.from(response.data).toString('utf8');
      try {
        response.data = res = JSON.parse(text);
      } catch (error) {
        return response;
      }
    } else if (response.request.responseType === 'blob') {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.addEventListener('abort', reject);
        reader.addEventListener('error', reject);
        reader.addEventListener('loadend', () => {
          try {
            let res = JSON.parse(reader.result);
            resolve(res);
          } catch (error) {
            reject(reader.result);
          }
        });
        reader.readAsText(response.data, 'utf-8');
      }).then(res => {
        if (res.code !== SUCCESS_CODE) {
          if (!response.config.noErrorAlert) {
            Message({
              message: res.msg || '网络错误！',
              type: 'error',
              duration: 5 * 1000,
              customClass:'messageBox'
            });
          }
          
          return Promise.reject(res);
        } else {
          return res;
        }
      });
    }

    if (res.code !== SUCCESS_CODE) {
      if (response.config.noErrorAlert) {
        return Promise.reject(res);
      } else {
        if (!canShow) {
          console.error({
            message: res.msg || '网络错误！',
            type: 'error',
            duration: 5 * 1000,
            customClass:'messageBox'
          })
          Message({
            message: res.msg || '网络错误！',
            type: 'error',
            duration: 5 * 1000,
            customClass:'messageBox'
          });
        }
      }

      // -2:其他客户端登录了;Token 过期了;
      if (res.code === LOGOUT_CODE) {
        if (logout) return;
        logout = true;
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            store
              .dispatch('FedLogOut')
              .then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              })
              .catch(err => {
                console.error('FedLogOutErr: ', err);
              });
          })
          .catch(err => {
            console.error(err);
            logout = false;
          });
      }
      console.error('err response: ', response);
      return Promise.reject(response.data);
    } else {
      return response.data;
    }
  }, errorHandle);
  return service;
};

const formateFetchUrl = url => {
  let baseURL = /https\:\/\//.test(location.origin)
    ? url.replace(headReg, 'https://')
    : url;
  return baseURL;
};
class ApiCreator {
  constructor() {
    return ApiCreator.getInstance();
  }
  static getInstance() {
    if (ApiCreator.instance) {
    } else if (window.ApiCreator) {
      ApiCreator.instance = window.ApiCreator;
    } else {
      ApiCreator.instance = createBaseFetch;
      window.ApiCreator = ApiCreator.instance;
    }

    return ApiCreator.instance;
  }
}

export default new ApiCreator();
